var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3606 23.182V5.61297H17.569V0.821411H3.19437V23.182H0V24.7792H11.1803V19.9876H14.3747V24.7792H25.555V23.182H22.3606ZM9.58312 16.7933H6.38875V13.5989H9.58312V16.7933ZM9.58312 12.0017H6.38875V8.80734H9.58312V12.0017ZM9.58312 7.21016H6.38875V4.01578H9.58312V7.21016ZM14.3747 16.7933H11.1803V13.5989H14.3747V16.7933ZM14.3747 12.0017H11.1803V8.80734H14.3747V12.0017ZM14.3747 7.21016H11.1803V4.01578H14.3747V7.21016ZM20.7634 16.7933H17.569V13.5989H20.7634V16.7933ZM20.7634 12.0017H17.569V8.80734H20.7634V12.0017Z",
    fill: "#7D7CA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyLogo);
export default __webpack_public_path__ + "static/media/CompanyLogo.eaa5f9ecb77e568be84fc6946d617068.svg";
export { ForwardRef as ReactComponent };